import zhLocale from "element-ui/lib/locale/lang/zh-CN";
const cn = {
  message: {
    title:"数字运营中心(网络版)", 
    login: "登录",
    upassword: "密码不可为空",
    password: "密码",
    uname: "账户",
    selectlang:"请选择语言",
    selectop1:"简体中文",
    selectop2:"English",
    editpassword:"修改密码",
    logout:"退出登录",
    oldpassword:"旧密码",
    newpassword:"新密码",
    confirmpassword:"确认密码",
    Pleaseenteryouroldpassword:"请输入旧密码",
    Pleaseenteranewpassword:"请输入新密码",
    Pleaseenterthepasswordagain:"请再次输入密码",
    Passwordlength:"密码长度为6-18位",
    Inconsistentpasswords:"两次输入密码不一致",
    cancel:"取 消",
    determine:"确 定",
    username:"用户名",
    Namecn:"姓名(CN)",
    Officecode:"办公代码",
    mailbox:"邮箱",
    telephone:"电话",
    region:"地区",
    department:"部门",
    state:"状态",
    operation:"操作",
    disable:"禁用",
    enable:"启用",
    Setrolestorepermissions:"设置角色店铺权限",
    Setroleinterfacepermissions:"设置角色接口权限",
    Pleaseenterthecontent:"请输入内容",
    homepage:"首页",
    systemmanagement:"系统管理",
    Rolemanagement:"角色管理",
    Roleinterfacepermissionconfiguration:"角色权限配置",
    Rolestorepermissionconfiguration:"角色店铺权限配置",
    usermanagement:"用户管理",
    channel:"渠道",
    Nameen:"姓名EN",
    Namecn:"姓名CN",
    Addemployee:"添加员工",
    DownloadFile:"下载文件",
    modify:"修改",
    delete:"删除",
    Assignpermissions:"分配权限",
    Usermenupermissionconfiguration:"用户菜单权限配置",
    Adduser:"添加用户",
    market:"所属区域",
    marketprice:"可查看区域",
    remarks:"备注",
    Modifyuser:"修改用户",
    Pleaseselect:"请选择",
    Pleaseenteralegalemailaddress:"请输入合法的邮箱",
    Pleaseenteravalidmobilephonenumber:"请输入合法的手机号",
    ALL:"查看所有",
    China:"中国",
    TaiwanChina:"中国台湾",
    HongKongChina:"中国香港",
    enteroneusername:"请输入用户名",
    Thelengthisbetween3and15characters:"长度在3-15个字符",
    Pleaseentertheuserpassword:"请输入用户密码",
    Thelengthisbetween6and15characters:"长度在6-15个字符",
    Pleaseselectadepartment:"请选择部门",
    Pleaseselectamarket:"请选择市场",
    ViewMarket:"请选择可查看市场",
    Pleaseenterusermailbox:"请输入用户邮箱",
    Pleaseentertheusersmobilephone:"请输入用户手机号码",
    Failedtogetpermissionlist:"获取权限列表失败",
    Allocationsucceeded:"分配成功",
    allocationfailed:"分配失败",
    FailedtogetDepartmentlist:"获取部门列表失败",
    Failedtogetuserinformation:"获取用户信息失败",
    Operationsucceeded:"操作成功",
    operationfailed:"操作失败",
    Deletesucceeded:"删除成功",
    Deletionfailed:"删除失败",
    Userinformation:"用户信息",
    Storeemployeemanagement:"店铺员工管理",
    Storecode:"店铺Code",
    StorenameCN:"店铺名称(CN)",
    StorenameeN:"店铺名称(EN)",
    contacts:"联系人",
    region:"区域",
    Setupemployees:"设置员工",
    Failedtogetpermissionlist:"获取权限列表失败",
    Inventorymanagement:"库存管理",
    Forceinventoryadjustment:"强制调整库存",
    Intelligentsearch:"智能搜索",
    Youcanenterproductnamearticlenumberandstorecodetoquery:"可输入品名,货号,店铺Code查询",
    Selectstore:"选择店铺",
    Selecttime:"选择时间",
    to:"至",
    Startdate:"开始日期", 
    Enddate:"结束日期",
    StartMonth:"开始月份", 
    EnddMonth:"结束月份",
    ProductName:"品名",
    serialnumber:"序列号",
    Numberofsystems:"系统数",
    Adjustinventory:"调整库存",
    Fillinadjustmentinformation:"填写调整信息",
    Uploadapprovalattachment:"上传审批附件",
    shop:"店铺",
    Adjustmenttype:"调整类型",
    Selectfile:"选取文件",
    Previousstep:"上一步",
    nextstep:"下一步",
    Addinventory:"加库存",
    Inventoryreduction:"减库存",
    yesterday:"昨天",
    today:"今天",
    lastweek:"上周",
    Thisweek:"本周",
    Lastmonth:"上月",
    Thismonth:"本月",
    Lastquarter:"上季度",
    Thisquarter:"本季度",
    lastyear:"去年",
    thisyear:"今年",
    Pleaseentertheadjustmentquantity:"请输入调整数量",
    Pleaseselectadjustmenttype:"请选择调整类型",
    Adjustmentquantitycannotbegreaterthansystemquantity:"调整数量不能大于系统数量",
    Filegreaterthan5m:"文件大于5M",
    Inventoryadjustmentinprogress:"库存调整中...",
    Pleaseloginagain:"请重新登录",
    Inventoryadjustment:"库存调整",
    Adjustmentquantity:"调整数量",
    Numberofsystems:"系统数量",
    Masterdatamanagement:"主数据管理",
    Dataupload:"数据上传",
    Selectuploadtype:"选择上传类型",
    Productmasterdata:"产品主数据",
    Productunitprice:"产品单价",
    Storeinformation:"店铺信息",
    upload:"上传",
    PushproductmasterinformationtoCRM:"推送产品主信息至crm",
    Onlyfilecanbeselected:"只能选择1个文件",
    ThefiletypeisnotanXlsxfileorXLSfile:"文件类型不是.xlsx文件或者.xls文件",
    Datauploading:"数据上传中",
    Datapushinprogress:"数据推送中",
    Batchmanagement:"批量管理",
    EctpJDreportupload:"ECTP-京东报表上传",
    ECTP:"ECTP",
    JD:"京东",
    Failureinformation:"失败信息",
    DistributionorderNo:"配货单号",
    Articlenumber:"货号",
    Sncode:"SN码",
    Orderdeliverytime:"订单发货时间",
    quantity:"数量",
    Actualpaymentamountofbuyer:"买家实际支付金额",
    Invoiceheader:"发票抬头",
    street:"街道",
    city:"城市",
    EtcpJDReportDownload:"ETCP-京东报表下载",
    Pleaseselectastarttimeandanendtime:"请选择开始时间和结束时间",
    Ecommercesales:"电商销售",
    InventoryreportDownload:"库存报表下载",
    stock:"库存",
    Inventoryreport:"库存报表",
    SalesReportDownload:"销售报表下载",
    sale:"销售",
    SalesReport:"销售报表",
    customerservice:"客户服务",
    Collaborativemanagement:"协同管理",
    Warehousewarehousing:"仓库入库",
    Batchnumber:"批号",
    Downloadallstockindetails:"下载所有入库明细",
    copy:"复制",
    download:"下载",
    PleaseenterSAPdocNo:"请输入SAP单号",
    Warehousedelivery:"仓库出库",
    Receiptvariance:"收货差异",
    Inventorynumber:"盘点单号",
    Countingtime:"盘点时间",
    Inventoryshop:"盘点店铺",
    applicant:"申请人",
    Inventoryvariance:"盘点差异",
    Productname:"产品名称",
    Numberofduplicatedisks:"复盘数",
    Differencephoto:"差异照片",
    CCreceipt:"CC收货",
    Confirmclosing:"确认关闭",
    Copysucceeded:"复制成功",
    Thebrowserdoesnotsupportautomaticreplication:"该浏览器不支持自动复制",
    SAPdocNocannotbeblank:"SAP单号不能为空",
    TherearealsoDNnumbersthathavenotbeenselected:"还有尚未选中的DN号",
    Confirmationsuccessful:"确认成功",
    Savedsuccessfully:"保存成功",
    Remarkscannotbeempty:"备注不能为空",
    Pleaseselectaproduct:"请选择产品",
    Deliveryshop:"发货店铺",
    OddNumbers:"单号",
    Returnreason:"退回原因",
    Storename:"店铺名称",
    Deliverytime:"出库时间",
    ReceiptNo:"收货单号",
    Receivingstore:"收货店铺",
    Receivingtime:"收货时间",
    WaybillNo:"运单单号",
    Shipper:"出货方",
    Consignee:"收货方",
    Productarticlenumber:"产品货号",
    productID:"产品序列号",
    Variancedetails:"差异详情",
    Differencesituation:"差异情况",
    Handlingsuggestions:"处理建议",
    Pleaseenterprocessingsuggestions:"请输入处理建议",
    preservation:"保存",
    time:"时间",
    Processingsuggestioncannotbeempty:"处理建议不能为空",
    CCsalesrecordquery:"CC销售记录查询",
    SalesOrderNo:"销售单号",
    Salestime:"销售时间",
    Salesticket:"销售小票",
    PleaseenternameCn:"请输入姓名CN",
    PleaseenternameEn:"请输入姓名EN",
    Thelengthisbetween1and15characters:"长度在 1到 15 个字符",
    Channel:"所属渠道",
    CourierNo:"运单号",
    Create:"创建时间",
    DLVtoWH:"交付仓库",
    WHCompletein:"仓库推送入库单",
    Post:"协同完成",
    SHPMNTStatus:"入库状态",
    PendingforReceipt:"仓库待收货总计",
    WHCompleteintotal:"入库总计",
    InboundComplete:"完成协同总计",
    ASNUpload:"上传",
    DLV :"送仓",
    Invalid:"失效",
    MAWB:"DN号",
    HAWB:"运单号",
    Warehouse:"仓库ID",
    Inboundtype:"类型",
    From:"店铺号",
    LOCNAME:"店铺名称",
    CarrierCompany:"运输公司",
    InventoryStatus:"入库状态",
    ETD:"预计出发时间",
    ETA:"预计到达时间",
    DateofArrival:"实际到货时间",
    DLVtoWHdate:"交付仓库时间",
    WHCompleteindate:"仓库推送入库单时间",
    Post:"协同完成时间",
    Query:"查询",
    DNNo:"DN 号",
    WHCompleteow:"推送出库单",
    DNStatus:"出库状态",
    DeclarationTotal:"关单总计",
    WHCompleteowTotal:"出库总计",
    OutboundCompleteTotal:"完成协同总计",
    NewDN:"新建",
    OutboundDNNo:"DN号",
    WHCompleteowdate:"仓库推送出库单时间",
    AddASN:"添加ASN",
    ASNDuplicatedata:"ASN重复数据",
    ASNInbounreport:"ASN入库报表",
    ErrMsg:"错误信息",
    ProductDescription:"产品描述",
    expBaseQty:"预到货数量",
    SKU:"货号",
    SerialNo:"序列号",
    WHManagement:"仓库管理",
    InboundManagement:"入库管理",
    OutboundManagement:"出库管理",
     DownloadforInboundReport:"仓库入库下载",
     DownloadforOutboundReport:"仓库出库下载",
     ASNOutboundreport:"ASN出库报表",
     StockReceptionfromPOS:"店铺转货收货",
     StockReceptionfromWarehouse:"仓库出库收货",
     Menupermissions:"菜单权限",
Storepermissions:"店铺权限",
CurrencyPermission:"币种权限",
IsEnable:"是否启用",
Enable:"启用",
Disable:"禁用",
SelectStockablestore:"选择可盘点店铺",
SaleRollReport:"滚动销售报表下载"
  },
  ...zhLocale
};

export default cn;


// WEBPACK FOOTER //
// ./src/i18n/lang/cn.js